import React from 'react';
import pt from 'prop-types';
import { combine } from '/src/helpers/styles';
import * as styles from './text.module.scss';
import { ifWordLetterLowercase } from '../../../helpers/copy';
import { useHeadlineContext } from '../../../context/HeadlineProvider/HeadlineProvider';

const Text = ({
  as,
  type,
  variant,
  style,
  className,
  children,
  withoutTransform,
  ...props
}) => {
  const isHeading = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(as);
  const [headlineAsH1] = useHeadlineContext(false, isHeading);
  const As = headlineAsH1 ? 'h1' : as;
  return (
    <As
      className={combine(
        styles[type],
        styles[variant],
        styles[style],
        className
      )}
      {...props}
    >
      {type === 'button' && typeof children === 'string' && !withoutTransform
        ? ifWordLetterLowercase(children)
        : children}
    </As>
  );
};

Text.propTypes = {
  as: pt.string,
  type: pt.string,
  variant: pt.string,
  style: pt.string,
  children: pt.node.isRequired,
  className: pt.string,
  withoutTransform: pt.bool,
};

Text.defaultProps = {
  as: 'p',
  type: 'p1',
  variant: '',
  className: '',
};

export default Text;
